import { PageType } from '@/types/pageType';

export type PageChrome = {
  pageType: PageType;
  hidePromoBanner: boolean;
  hideChatButton: boolean;
  showBackToTop: boolean;
};

const DESIGNER_ROUTE = '/cyo/designer';
const TOTW_ROUTE = '/shop/totw';

/**
 * Routes whose filters and sorting sit at the top of the page, so scrolling
 * back up is worth a shortcut. Deliberately not every long page — TOTW, the
 * PDP and the SEA page have no filters to scroll back to.
 */
const LIST_PAGE_ROUTES = [
  '/shop/[[...slug]]',
  '/shop/user/[[...slug]]',
  '/cyo/assortment/list/[[...slug]]',
];

const deriveNavigationChrome = (route: string): Omit<PageChrome, 'showBackToTop'> => {
  if (route === DESIGNER_ROUTE) {
    return { pageType: 'DESIGNER', hidePromoBanner: false, hideChatButton: true };
  }
  if (route === TOTW_ROUTE) {
    return { pageType: 'MP', hidePromoBanner: true, hideChatButton: false };
  }
  if (route.startsWith('/shop')) {
    return { pageType: 'MP', hidePromoBanner: false, hideChatButton: false };
  }
  if (route.startsWith('/cyo')) {
    return { pageType: 'CYO', hidePromoBanner: false, hideChatButton: false };
  }
  if (route.startsWith('/pro')) {
    return { pageType: 'DEFAULT', hidePromoBanner: true, hideChatButton: false };
  }
  return { pageType: 'DEFAULT', hidePromoBanner: false, hideChatButton: false };
};

/**
 * The page shell lives in a single shared layout, so per-page chrome cannot be
 * passed down as props. It is derived from the internal route instead — the
 * pathname `usePathname` from `@/i18n/navigation` returns, which is the
 * unlocalized App Router route (`/shop/totw`, never `/shop/t-shirt-der-woche`).
 *
 * When adding a page type that needs different chrome, add it here.
 */
export const derivePageChrome = (route: string): PageChrome => ({
  ...deriveNavigationChrome(route),
  showBackToTop: LIST_PAGE_ROUTES.includes(route),
});
